export default function getCurrentYearDateUtil () {
  const currentDate = new Date()
  return currentDate.getFullYear()
}
